/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfPresentUserListDto } from '../../models/platform-api-result-of-present-user-list-dto';

export interface GetDevicesQueryPresentuserlistPcname$Params {
  pcName: string;
}

export function getDevicesQueryPresentuserlistPcname(http: HttpClient, rootUrl: string, params: GetDevicesQueryPresentuserlistPcname$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfPresentUserListDto>> {
  const rb = new RequestBuilder(rootUrl, getDevicesQueryPresentuserlistPcname.PATH, 'get');
  if (params) {
    rb.path('pcName', params.pcName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfPresentUserListDto>;
    })
  );
}

getDevicesQueryPresentuserlistPcname.PATH = '/api/devices/query/presentuserlist/{pcName}';
